export const percentageBetween = (val: number, min: number, max: number) =>
  (val - min) / (max - min);
